import type { MouseEvent } from 'react'
import { Link } from './nav'
import { ArrowLeft } from 'lucide-react'
import './BackLink.css'

export interface BackTarget {
  /** The parent surface's name, e.g. "Test Runs". */
  label: string
  to: string
  /** Intercept the click — e.g. to run a view-transition navigation instead. */
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void
}

/**
 * The way out of a detail page that the tab bar does not cover: one link to the parent surface,
 * matching the arrow-and-label header the bug and test-run pages use. This replaced the breadcrumb
 * trail these pages carried — with the project tabs restored, a full trail only re-stated where the
 * visitor already knows they are.
 */
export default function BackLink({ target }: { target: BackTarget }) {
  return (
    <Link to={target.to} className="back-link" onClick={target.onClick} data-analytics-event="breadcrumb-link">
      <ArrowLeft size={15} aria-hidden="true" /> {target.label}
    </Link>
  )
}
